<template>
    <div
        style="
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            background-color: #00000020;
        "
    >
        <v-progress-circular
            :size="100"
            :width="10"
            color="blue"
            indeterminate
        ></v-progress-circular>
        <br />
        <br />
    </div>
</template>

<script>
export default {};
</script>
